import React, { Fragment } from 'react';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next/hooks';
// import { useSearchParams, useNavigate } from "react-router-dom";

import Button from '../../Button/Button';
import Loader from '../../Loader/Loader';
import SmallModal from '../../Modal/SmallModal';
import TransBackdrop from '../../Backdrop/TransBackdrop';
import GroupLoadParamContent from './GroupLoadParamContent';

import { addRecentVisitGroupId } from '../../../util/user-recent-visit';
import { 
  getObjectFile,
} from '../../../util/bucket/bucket-object-util';

// import {
//   createImagePreviews,
// } from '../../../util/talk/talk-file';

import { useStore } from '../../../hook-store/store';

import { 
  SOCKET_GROUP_URL,
  KURAIMAGEPHOTO_BACKENDURL,
  KURASTORAGE_BACKENDURL,
  BASE_URL,
} from '../../../App';

import { marks } from '../../../images/marks';
import classes from './GroupLoadParamBucketFile.module.css';

const GroupLoadParamBucketFile = props => {
  // console.log('VideoTextTalkUpload.js-props', props);
  const { 
    groupList,
    userId,
    showGroupTalkTextHandler,
    getGroupInfoHandler,
  } = props;

  const [t] = useTranslation('translation');

  // let [searchParams, setSearchParams] = useSearchParams();

  const [store, dispatch] = useStore();
  const { isAuth } = store.uiStore;
  const { groupParamFileData } = store.groupStore;

  const [paramFileSelectGroup, setParamFileSelectGroup] = useState('');
  const [showLoadParamModal, setShowLoadParamModal] = useState(false);
  const [fileLoading, setFileLoading] = useState(false);
  const [keyData, setKeyData] = useState();
  const [textInput, setTextInput] = useState();

  // const currentUrl = new URL(window.location.href);
  // const queryParams = currentUrl.searchParams;
  
  // let keyData = queryParams.get('keyData');
  // if (keyData) {
  //   keyData = JSON.parse(keyData);
  //   // console.log(keyData)
  // }

  let isSameUser = false;

  if (keyData?.userId === userId) {
    isSameUser = true;
  }

  // {
  //   bucket: ,
  //   key: ,
  //   initialKey: ,
  //   mimeType: ,
  //   userId,
  //   openApp,
  // }

  // const key = queryParams.get('key');
  // const mimeType = queryParams.get('mimeType');
  // const kuraStorageUserId = queryParams.get('kuraStorageUserId');
  // const pathname = window.location.pathname;
  
  useEffect(() => {
    const currentUrl = new URL(window.location.href);
    const queryParams = currentUrl.searchParams;
    
    let paramKeyData = queryParams.get('keyData');
    if (paramKeyData) {
      paramKeyData = JSON.parse(paramKeyData);
      console.log('paramKeydata', paramKeyData)
      
      if (Date.now() < paramKeyData.expire) {
        // setKeyData(paramKeyData);
        setKeyData({
          ...paramKeyData,
          // key: encodeURI(paramKeyData.key),
          // initialKey: encodeURI(paramKeyData.initialKey),
          key: paramKeyData.key,
          initialKey: paramKeyData.initialKey,
        });
        setShowLoadParamModal(true);
      }
    }
  },[]);

  useEffect(() => {
    if (isAuth && !groupParamFileData && 
          paramFileSelectGroup && keyData
    ) {
      getParamBucketFileHandler(
        keyData.bucket,
        keyData.key,
        keyData.initialKey,
        keyData.mimeType,
        paramFileSelectGroup,
        keyData.userId,
        keyData.openApp,
        textInput,
        keyData.size,
      );
    } 
  },[isAuth, groupParamFileData, paramFileSelectGroup]);


  const addVisitGroupIdHandler = async (groupId, creatorId) => {
    try {
      if (localStorage.getItem('userId') && creatorId !== localStorage.getItem('userId')) {
        await addRecentVisitGroupId(
          BASE_URL, 
          localStorage.getItem('token'),
          groupId, 
          creatorId
        );
        // console.log(resData);
      }
    } catch(err) {
      console.log(err);
    }
  }

  const clickGroupNameHandler = (group) => {
    showGroupTalkTextHandler(group.groupRoomId);
    getGroupInfoHandler(group.groupRoomId); 
    addVisitGroupIdHandler(
      group.groupRoomId,
      group.creatorUserId,
    );
  };

  const getParamBucketFileHandler = async (
    bucket, 
    key, 
    initialKey,
    mimeType,
    group,
    userId,
    openApp,
    textInput,
    size,
  ) => {
    try {
      setFileLoading(true);

      let bFile;

      if (mimeType.split('/')[0] === 'image') {
        let backendUrl = KURASTORAGE_BACKENDURL;

        // if (bucket.endsWith('image-photo')) {
        //   backendUrl = KURAIMAGEPHOTO_BACKENDURL;

        //   const resData = await getObjectFile(
        //     backendUrl,
        //     localStorage.getItem('token'),
        //     bucket,
        //     key,
        //     mimeType,
        //   );
    
        //   if (resData) {
        //     const pathSplit = key.split('.');
        //     const ext = pathSplit.pop();
              
        //     bFile = new File(
        //       [resData],
        //       `group-kura-file-${group.groupRoomId}-${bucket}.${ext}`, 
        //       { type: mimeType },
        //     );
        //   }
        // }
        
    }

    dispatch('SET_GROUPPARAMFILEDATA', {
      userId: userId,
      openApp: openApp,
      groupRoomId: group.groupRoomId,
      bucket: bucket,
      key: key,
      initialKey: initialKey,
      mimeType: mimeType,
      file: bFile,
      textInput: textInput,
      size: size,
    });

      clickGroupNameHandler(group);
    
      setFileLoading(false);
    } catch(err) {
      console.log(err);

      setFileLoading(false);
      throw err;
    }
  };


  const showLoadParamModalHandler = () => {
    setShowLoadParamModal(!showLoadParamModal);
  }

  let groupLoadParamBucketFileBody;
  
  if (showLoadParamModal) {
    groupLoadParamBucketFileBody = (
      <div>
        <TransBackdrop 
          onClick={showLoadParamModalHandler} 
        />
        <SmallModal
          // style={classes.groupLoadParamBucketFileModal}
        >
          <div>
            <div className={classes.groupLoadParamBucketFileModalClose}>
              <span
                onClick={showLoadParamModalHandler} 
              >
                X
              </span>
            </div>
            <GroupLoadParamContent 
              groupList={groupList}
              userId={userId}
              paramFileSelectGroup={paramFileSelectGroup}
              setParamFileSelectGroup={setParamFileSelectGroup}
              showLoadParamModalHandler={showLoadParamModalHandler}
              fileLoading={fileLoading}
              isSameUser={isSameUser}
              textInput={textInput}
              setTextInput={setTextInput}
              keyData={keyData}
              // showGroupTalkTextHandler={showGroupTalkTextHandler}
              // getGroupInfoHandler={getGroupInfoHandler}
            />
          </div>
        </SmallModal>
      </div>
    );
  }

  return (
    <Fragment>
      <div>{groupLoadParamBucketFileBody}</div>
    </Fragment>

  );
}

export default GroupLoadParamBucketFile;